<template>
    <div class="content-page">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="d-flex flex-wrap align-items-center justify-content-between mb-4">
                        <div>
                            <h4 class="mb-3">Valid tickets list</h4>
                            
                        </div>
                        <div class="row" v-if="permissions.includes('filter-tickets')">
                            From : <input class="form-control col-lg-4" @change="first" type="date" v-model="payload.from" name="" id="">
                            To : <input class="form-control col-lg-4" @change="second" type="date" v-model="payload.to" name="" id="">
                        </div>
                        <div>
                            <button @click="printPage()" class="btn mt-10 btn-primary mr-2">Print</button>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="d-flex justify-content-end mb-3">
                        <input v-model="tableSearch" type="search" class="form-control" style="max-width: 360px;" placeholder="Search tickets" aria-label="Search tickets">
                    </div>
                    <div class="table-responsive rounded mb-3" v-if="payload.from != '' && payload.to != ''">
                        <table id="tbl_exporttable_to_xls"  class="data-table table mb-0 tbl-server-info">
                            <thead class="bg-white text-uppercase">
                                <tr class="ligth ligth-data">
                                    <th>Meal type </th>
                                    <th>Quantity</th>
                                    <th>Unit price</th>
                                    
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody class="ligth-body">
                                <tr v-for="(bail,index) in bails" :key="index">
                                    <td>{{bail.libelle}}</td>
                                    <td>{{bail.qteTotal}}</td>
                                    <td>{{formatPrice(bail.buy_price)}}</td>
                                    <td>{{formatPrice(bail.coutTotal)}} XOF</td>  
                                </tr>
                                <tr>
                                    <td>Total amount : </td>
                                    <td></td>
                                    <td></td>
                                    <td> {{formatPrice(this.cout )}} XOF</td>
                                </tr>
                            </tbody>
                        </table>
                        <button v-if="permissions.includes('export-tickets')" @click="ExportToExcel('xlsx', 'tbl_exporttable_to_xls')" class="btn mt-10 btn-primary mr-2">Export</button>
                    </div>
                    <div class="table-responsive rounded mb-3" v-else>
                        <table id="example"  class="data-table table mb-0 tbl-server-info">
                            <thead class="bg-white text-uppercase">
                                <tr class="ligth ligth-data">
                                    <th>Code</th>
                                    <th>Quantity</th>
                                    <th>Purchased by</th>
                                    <th>Valid until</th>
                                </tr>
                            </thead>
                            <tbody class="ligth-body">
                                <tr v-for="(bail,index) in filteredTickets" :key="index">
                                    <td>{{bail.code}}</td>
                                    <td>{{bail.qte}}</td>
                                    <th v-if="bail.purchased_by">{{bail.purchased_by.nom}} {{bail.purchased_by.prenoms}} ({{bail.purchased_by.matricule}})</th>
                                    <th v-else></th>
                                    <td>{{bail.validite}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- Page end  -->
        </div>
        <!-- Modal Edit -->
            <div class="vld-parent">
                <loading v-model:active="isLoading"
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
            </div>
    </div>
</template>
<script>
import axios from "axios";
import * as XLSX from 'xlsx/xlsx.mjs'

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/css/index.css';
import Swal from 'sweetalert2'
import moment from 'moment'
moment.locale('fr')
export default {
    components: {
            Loading
    },
    data() {
        return {permissions: [],
            tickets:{},
            tableSearch: '',
            bails:[],
            payload:{
                from: '',
                to: '',
                expired: 0,
                valid: 1,
            },
            cout: 0,
            isLoading: false,
            fullPage: true,
            types: null
        };
    },
    mounted(){this.$store.state.user.permissions.forEach(element => {
            this.permissions.push(element.name)
        });
        this.getTickets('tiket-print')
    },
    computed: {
        filteredTickets() {
            const search = this.tableSearch.trim().toLowerCase()
            const tickets = Array.isArray(this.tickets) ? this.tickets : []
            return search ? tickets.filter(ticket => [ticket.code, ticket.qte, ticket.validite, ticket.purchased_by && ticket.purchased_by.nom, ticket.purchased_by && ticket.purchased_by.prenoms, ticket.purchased_by && ticket.purchased_by.matricule].some(value => String(value || '').toLowerCase().includes(search))) : tickets
        },
    },
    methods:{
        printPage() {
            setTimeout(function(){
                    window.print();
            }, 1000);
        },
        formatPrice(value) {
            let val = (value/1).toFixed(0).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        ExportToExcel(type, table, fn, dl) {
        var elt = document.getElementById(table);
        var wb = XLSX.utils.table_to_book(elt, { sheet: "sheet1" });
        return dl ?
            XLSX.write(wb, { bookType: type, bookSST: true, type: 'base64' }):
            XLSX.writeFile(wb, fn || ('Sells sheet - '+ this.payload.from +'-'+ this.payload.to +'.' + (type || 'xlsx')));
        },
        getBails() {
            this.isLoading =  true
            axios.post('calcul-ticket', this.payload)
            .then(reponse => {
                this.isLoading = false
                console.log('bails', reponse)
                if (reponse.data.status == true) {
                    this.bails = reponse.data.data
                    this.cout = reponse.data.cout
                    if (this.bails.length == 0) {
                        Swal.fire('Note', 'No ticket printed in this period!', 'info')
                    }
                }
            })
            .catch(error => {
                this.isLoading = false
                console.log(error)
                this.errored = true
                
            })
            
        },
        first() {
            if (this.payload.from != '') {
                if (this.payload.to != '') {
                    this.getBails()
                } else {
                    Swal.fire('Note', 'Enter end date.', 'info')
                }
            } else {
                Swal.fire('Note', 'Enter begin date.', 'info')
            }
        },
        second() {
            if (this.payload.to != '') {
                if (this.payload.from != '') {
                    this.getBails()
                } else {
                    Swal.fire('Note', 'Enter begin date.', 'info')
                }
            } else {
                Swal.fire('Note', 'Enter end date.', 'info')
            }
        },
        getTickets(arg) {
            this.isLoading =  true
            axios.get(arg)
            .then(response => {
                console.log(response)
                response.data.data.forEach(element => {
                    element.created_at = moment(element.created_at).format('DD/MM/YYYY')
                });
                this.tickets = response.data.data
                this.isLoading =  false
            })
            .catch(error => {
                console.log(error)
                this.errored = true
                Swal.fire(
                        'Erreur!',
                        'An error occured while fetching datas',
                        'error'
                )
                this.isLoading =  false
            })
        },
        destroy(id) {
            Swal.fire({
                title: 'Do you want to delete this ticket ?',
                text: "This action is irreversible!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes deleted!'
            }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading =  true
                axios.delete('tiket-print/'+id)
                .then(response => {
                    console.log(response.data)
                    this.tickets = response.data
                    this.isLoading =  false
                    Swal.fire(
                        'Deleted!',
                        'The ticket was deleted.',
                        'success'
                    )
                    location.reload()
                })
                .catch(error => {
                    console.log(error)
                    this.errored = true
                    this.isLoading =  false
                })
                
            }
            })
            
        },
    }
}
</script>